import { updateEmploymentType } from "../../../../../actions/Utilities/EmploymentType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useUpdateEmploymentType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (employmentTypeNewData) => updateEmploymentType(employmentTypeNewData),
    {
      onSuccess: (res) => {
        if (res == "Duplicate") {
          toast.fire(
            "Saving Failed",
            "Employment Type already exists!",
            "error"
          );
        } else {
          queryClient.invalidateQueries(["GetEmploymentType"]);
          toast.fire(
            "Success",
            "Employment Type Updated Successfully",
            "success"
          );
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update Employment Type", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateEmploymentType;
